import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import DetachPreview from "../../features/previews/detach/DetachPreview";
import DetachNodePreview from "../../features/sequence/node_previews/DetachNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";

export interface IDetach extends Interaction {
  propGuid: string;
  playerGuid: string;
}

export const detachInteraction = (): InteractionFactoryEntity => {
  const component = <DetachPreview />;

  const create = (getKeys: (amount: number) => string[]): IDetach => {
    return {
      id: GetNewGuid(),
      name: "Detach",
      type: InteractionType.Detach,
      propGuid: "",
      playerGuid: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IDetach => {
    return interaction as IDetach;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): IDetach => {
    const original = interaction as IDetach;
    return {
      ...original,
      id: GetNewGuid(),
    };
  };

  const validateErrors = (interaction: Interaction): string[] => {
    const detach = interaction as IDetach;
    const errors: string[] = [];

    if (!detach.propGuid?.trim()) errors.push("Prop is required");
    if (!detach.playerGuid?.trim()) errors.push("Actor is required");

    return errors;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[],
    _getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext,
  ): SearchResultData[] => {
    const converted = interaction as IDetach;
    const searchableStrings = compactSearchableStrings(
      interaction.name,
      searchLookupContext?.getPropSearchTerms(converted.propGuid) ??
        converted.propGuid,
      searchLookupContext?.getActorSearchTerms(converted.playerGuid) ??
        converted.playerGuid,
    );

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType
    );
  };

  const filterType: string = "Detach";

  return {
    View: component,
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Filter: filter,
    ValidateErrors: validateErrors,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <DetachNodePreview nodeId={nodeId} interaction={interaction} />
    ),
  };
};
